import {Component, OnInit} from '@angular/core';
import { LimeProxiesService } from '../../services/limeproxies.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
declare const $: any;

@Component({
    selector: 'invoice-main',
    templateUrl: '../../templates/receipt/receipt.template.html'
})

export class ReceiptComponent implements OnInit {

    invoiceData: any;
    user: any;

    constructor(private limeProxiesService: LimeProxiesService, private router: Router) {
    }

    ngOnInit() {
        if (this.limeProxiesService.getCachedInvoice()) {
            this.invoiceData = this.limeProxiesService.getCachedInvoice();
        } else {
            this.router.navigate(['/billing/', 'history']);
        }
        this.limeProxiesService.setTitle('Receipt');
        this.limeProxiesService.getUserProfile()
            .subscribe(
                profile => {
                  this.user = profile;
                }
            );
    }

    printReceipt() {
        const selector = $('.btn-receipt-print');
        selector.hide();
        window.print();
        selector.show();
    }

    formatDate(date: any) {
        return moment(date).format('LL');
    }

    getInvoiceId(date: any) {
        return moment(date).unix();
    }
}
